import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  max-width: 100%;
  padding: 0;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex: 1;
  flex-direction: column;
`;
